import req from "../http";

const education = {
  // 取得 學校
  getSchool(params) {
    return req("get", "/BasicInformation/School", params);
  },

  // 取得 科系
  getMajor(params) {
    return req("get", "/BasicInformation/Major", params);
  },

  // 取得 學歷程度
  getEducationDegree(params) {
    return req("get", "/BasicInformation/EducationDegree", params);
  }
};

export default education;